import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { HeadlineWebComponent } from '@resident-nx/web';
import { TranslateModule } from '@ngx-translate/core';
import {
  getFederatedLoginDataActionState,
  LoadFederatedLoginWeb,
} from '@resident-nx/web/data-access';
import { getNonceAndState, getRedirectUrl } from '@resident-nx/web/util';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';
import { ImmomioAnchorComponent, ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'rs-web-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadlineWebComponent,
    ReactiveFormsModule,
    TranslateModule,
    ImmomioFormFieldComponent,
    ImmomioButtonComponent,
    ImmomioAnchorComponent,
    FormsModule,
  ],
})
export class LoginComponent {
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private store = inject(Store);
  readonly federatedLoginDataActionState = this.store.selectSignal(
    getFederatedLoginDataActionState
  );

  public emailControl = this.fb.control('', {
    validators: [Validators.required, Validators.email],
  });

  public navigateToRegistration() {
    void this.router.navigate(['/registration']);
  }

  public submit() {
    const { nonce, state } = getNonceAndState();
    const redirectUri = getRedirectUrl(window.location.toString(), '/auth', {
      pathAfterAuth: '/home',
    });

    const email = this.emailControl.value;
    this.store.dispatch(
      LoadFederatedLoginWeb({ email, nonce, state, redirectUri, loginSource: 'WEB' })
    );
  }

  public navigateToRequestResetPasswordPage() {
    void this.router.navigate(['/request-reset-password']);
  }
}
